import { JSX } from 'react'

import { IconProps } from '../../icon'

const Clock: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M23.5 8C14.6713 8 7.5 15.1713 7.5 24C7.5 32.8287 14.6713 40 23.5 40C32.3287 40 39.5 32.8287 39.5 24C39.5 15.1713 32.3287 8 23.5 8ZM23.5 37.5385C16.0333 37.5385 9.96154 31.4667 9.96154 24C9.96154 16.5333 16.0333 10.4615 23.5 10.4615C30.9667 10.4615 37.0385 16.5333 37.0385 24C37.0385 31.4667 30.9667 37.5385 23.5 37.5385Z'
      fill='black'
    />
    <path
      d='M31.7051 22.7692H24.7308V15.7949C24.7308 15.1221 24.1728 14.5641 23.5 14.5641C22.8272 14.5641 22.2692 15.1221 22.2692 15.7949V24C22.2692 24.6728 22.8272 25.2308 23.5 25.2308H31.7051C32.3779 25.2308 32.9359 24.6728 32.9359 24C32.9359 23.3272 32.3779 22.7692 31.7051 22.7692Z'
      fill='black'
    />
  </svg>
)

export default Clock
